"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputWrap = exports.resolveOnChange = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styles_1 = require("@material-ui/styles");
var Input_1 = tslib_1.__importDefault(require("@material-ui/core/Input"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    InputWrapWrap: {
        display: "flex",
        alignItems: "center",
    },
    InputWrapView: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: 18,
        padding: 10,
        borderStyle: "solid",
        borderWidth: 1,
        borderRadius: 3,
        borderColor: theme !== undefined ? theme.app.Setting.color9 : "",
        backgroundColor: theme !== undefined ? theme.app.Setting.color13 : "",
    },
    Input: {
        width: "100%",
        fontSize: 16,
        fontWeight: 400,
        color: theme !== undefined ? theme.app.Setting.color15 : "",
        backgroundColor: theme !== undefined ? theme.app.Setting.color13 : "",
    },
}); });
function resolveOnChange(e, onChange) {
    if (onChange) {
        var event_1 = e;
        if (e.type === "click") {
            event_1 = Object.create(e);
            onChange(event_1);
            return;
        }
        onChange(event_1);
    }
}
exports.resolveOnChange = resolveOnChange;
function InputWrap(props) {
    var classes = useStyles();
    var placeholder = props.placeholder, onChange = props.onChange;
    var _a = tslib_1.__read(react_1.default.useState(""), 2), value = _a[0], setValue = _a[1];
    var handleChange = function (e) {
        resolveOnChange(e, onChange);
        setValue(e.target.value);
    };
    return (react_1.default.createElement("div", { className: classes.InputWrapWrap },
        react_1.default.createElement("div", { className: classes.InputWrapView },
            react_1.default.createElement(Input_1.default, { className: classes.Input, placeholder: placeholder, disableUnderline: true, value: value, onChange: handleChange }))));
}
exports.InputWrap = InputWrap;
//# sourceMappingURL=inputWrap.js.map